<template>
	<div class="subhead-lockup" :class="{ 'subhead-lockup--has-button': button }">
		<component
			:is="titleElement"
			v-if="tooltip"
			:id="titleId"
			class="subhead-lockup__subhead"
		>
			<span :title="tooltip">{{ title }}</span>
			<FootnoteLink v-if="footnote" :footnote="footnote" />
		</component>
		<component
			:is="titleElement"
			v-else
			:id="titleId"
			class="subhead-lockup__subhead"
		>
			{{ title }}
			<FootnoteLink v-if="footnote" :footnote="footnote" />
		</component>
		<p class="p2 subhead-lockup__detail" v-if="detail" v-html="detail" />
		<a
			v-if="button && buttonUrl"
			class="button button--black"
			:title="buttonDescription ? buttonDescription : 'Opens a PDF'"
		>
			{{ button }}
			<span v-if="visuallyHiddenDescription" class="visually-hidden">
				{{ visuallyHiddenDescription }}
			</span>
			<span class="icon icon-download" aria-hidden="true" />
		</a>
		<button
			v-else-if="button && buttonAction && !this.$parent.error"
			class="button button--black"
			@click="buttonAction"
			:title="buttonDescription ? buttonDescription : 'Downloads a file'"
		>
			{{ button }}
			<span v-if="visuallyHiddenDescription" class="visually-hidden">
				{{ visuallyHiddenDescription }}
			</span>
			<span class="icon icon-download" aria-hidden="true" />
		</button>
	</div>
</template>

<script>
import FootnoteLink from "../footnote-link/FootnoteLink";

/**
 * A layout  template containing a heading, description, and optional action button.
 */
export default {
	name: "SubheadLockup",
	components: { FootnoteLink },
	props: {
		/**
		 * Set the header text
		 */
		title: {
			type: String,
			required: true
		},

		/**
		 * Set the description or detail text that appears below the header.
		 */
		detail: String,

		/**
		 * If you want an actionable button to appear on the top-right, set the optional button text string.
		 */
		button: String,

		/**
		 * If you want a tooltip message to appear with the header, set the message string here.
		 */
		tooltip: String,

		/**
		 * Add a footnote link to the title.
		 */
		footnote: String | Number,

		/**
		 * Set an href url string if the button should behave like an anchor link.
		 */
		buttonUrl: String,

		/**
		 * Set the button's onClick() action.
		 */
		buttonAction: {
			type: Function,
			default: function () {}
		},

		/**
		 * **A11Y** Button's functional description (ex: "Opens a new window")
		 */
		buttonDescription: {
			type: String
		},

		/**
		 * Set HTML header element.
		 */
		titleElement: {
			type: String,
			default: "h3"
		},

		/**
		 * Add an ID to the header element.
		 */
		titleId: {
			type: String
		},

		/**
		 * Visually hidden description of a button (a11y).
		 */
		visuallyHiddenDescription: {
			type: String
		}
	}
};
</script>

<style lang="scss">
.subhead-lockup {
	@include from-md {
		align-items: baseline;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		margin-bottom: 22px;

		.subhead-lockup__subhead {
			margin-bottom: 10px;
			transform: translateY(3px);
		}

		.subhead-lockup__detail {
			flex: 1 1 100%;
			max-width: 100%;
			margin-bottom: 0;
			margin-top: 8px;
			order: 3;
		}

		&--has-button {
			margin-top: -6px;
		}
	}

	@include to-md {
		.subhead-lockup__subhead {
			margin-bottom: 10px;

			+ button {
				margin-top: 15px;
			}
		}

		.subhead-lockup__detail {
			font-size: 14px;
		}

		button {
			margin-bottom: 10px;
			width: 100%;
		}
	}
}
</style>
